import { render } from "./BadgeDisplay.vue?vue&type=template&id=0a3a26ec&scoped=true"
import script from "./BadgeDisplay.vue?vue&type=script&lang=js"
export * from "./BadgeDisplay.vue?vue&type=script&lang=js"

import "./BadgeDisplay.vue?vue&type=style&index=0&id=0a3a26ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3a26ec"]])

export default __exports__